export default __webpack_public_path__ + "static/media/sweet-spot-1-gsec-fof.def6c560.png";